import React, { Component } from 'react';

export class ExternalLayout extends Component {
  static displayName = ExternalLayout.name;

  render () {
    return (
        <div className="container-fluid px-1 py-5 mx-auto" style={{background: '#00407a'}}>
            <div className="row d-flex justify-content-center">
                <div className="col-md-2 col-4">
                    <img src="./img/logo_ENI_blc.svg" alt="logo ENI" style={{height: '100px'}}/>
                </div>
                <div className="col-md-9 col-7" style={{color:'white'}}>
                    <div className="row">
                        <h1>ENI Ecole Informatique</h1>
                    </div>
                    <div className="row">
                        <h3>Rejoindre l'aventure ENI</h3>
                    </div>
                </div>
            </div>
        </div>
    );
  }
}
